import React from 'react';
import HorizontalTabs from "../../../ui/tabs/HorizontalTabs";
import ScoutingInvites from "../scouting/ScoutingInvites";
import RejectedScoutings from "../scouting/RejectedScoutings";
import MyScoutings from "../scouting/MyScoutings";
import SavedScoutings from "../scouting/SavedScoutings";
import SharedScoutings from "../scouting/SharedScoutings";
import "../../../../assets/sass/pages/scouting/scouting.scss";

const Scouting = (props) => {

    const items = [
        HorizontalTabs.createItem('Scouting Invites', <ScoutingInvites/>),
        HorizontalTabs.createItem('My Scoutings', <MyScoutings/>),
        HorizontalTabs.createItem('Saved Scoutings', <SavedScoutings/>),
        HorizontalTabs.createItem('Shared Scoutings', <SharedScoutings/>),
        HorizontalTabs.createItem('Rejected Scoutings', <RejectedScoutings/>),
    ];

    return (
        <div className="scouting-wrapper">
            <HorizontalTabs items={items}/>
        </div>
    );
}

export default Scouting;
